const Radio = {
  parts: ['control'],
  baseStyle: {},
  defaultProps: {
    size: 'md',
    colorScheme: 'brand.primary',
  },
};

export default Radio;
